import IdListDTO from '../IdListDTO';
import StringValueDTO from '../stringValue/stringValueDTO';
import { KPI_TranslationDTO } from './kpi_TranslationDTO';
import KPIAlertDTO from './KPIAlertDTO';
import KPIDataDTO from './kpiDataDTO';
import KPIGraphDataDTO from './kpiGraphDataDTO';

export default class KPIDTO {
  kpiId: number;

  currentDefinitionRevisionId?: number;

  currentDefinitionRevisionNumber?: number;

  ownerTaskTypeFamilyId?: number;

  rowVersion?: string;

  authSchemaId?: number;

  auditTrailId?: number;

  type: number;

  minValue: string | undefined;

  maxValue: string | undefined;

  decimalCount: number | undefined;

  defValue: string | undefined;

  required: boolean;

  attachmentMode?: number;

  listId?: number;

  folderId?: string;

  commentMode?: number;

  systemKPIType?: number;

  isSystem: boolean;

  isField: boolean;

  showLabel: boolean;

  tagIds: IdListDTO;

  controlIds?: IdListDTO;

  objectiveIds?: IdListDTO;

  data?: KPIDataDTO[];

  graphData?: KPIGraphDataDTO;

  alerts: KPIAlertDTO[];

  trans: KPI_TranslationDTO[];

  hasAutomatedEvidence: boolean;

  choices?: StringValueDTO[];

  taskTypeIds?: IdListDTO;

  dashboardIds?: IdListDTO;

  integrationIds?: IdListDTO;

  // KPIUsageKind values, distinct; filled by the KPI list only
  usageKinds?: number[];

  // the rows the usage modal lists; filled by the KPI list only
  usageCount?: number;

  constructor() {
    this.kpiId = 0;
    this.trans = [];
    this.auditTrailId = 0;
    this.type = 0;
    this.required = false;
    this.tagIds = new IdListDTO([]);
    this.alerts = [];
    this.hasAutomatedEvidence = false;
    this.showLabel = true;
    this.isSystem = false;
    this.isField = false;
  }
}
